<template>
  <div>
    <el-select :popper-append-to-body='false' v-model="start_year" placeholder="最低" @change="changeStartYear">
      <el-option v-for="item in startYearOption" :key="item" :label="item" :value="item">
      </el-option>
    </el-select>
    <span style="margin: 0 15px;" v-if="start_year">
      -
    </span>
    <el-select :popper-append-to-body='false' v-if="start_year" v-model="end_year" placeholder="最低" @change="changeEndYear">
      <el-option v-for="item in endYearOption" :key="item" :label="item" :value="item">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "",
   props: [
    "graduation_end_year",
    "graduation_start_year",
  ],
  data() {
    return {
      start_year: "",
      end_year: "",
      startYearOption: [],
      endYearOption: [],
    };
  },
   watch: {
    graduation_start_year: {
      handler(newVal) {
        this.start_year=this.graduation_start_year
        this.end_year=this.graduation_end_year
        this.changeStartYear()
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.startYearOption = this.getYearsArray(currentYear, 2);
  },
  methods: {
    getYearsArray(start, num) {
      // 获取当前年份
      // 创建包含当前年份和之后4年的数组
      let years = [];
      if (num == 2) {
        years = ["不限", start - 1];
      } else {
        years = [];
      }
      for (let i = 0; i <= num; i++) {
        years.push(start + i);
      }

      return years;
    },
    changeStartYear() {
      if (this.start_year == "不限") {
        this.endYearOption = ["不限"];
      } else {
        this.endYearOption = this.getYearsArray(this.start_year, 1);
      }
      this.end_year = this.endYearOption[0];
    },
    changeEndYear() {},
  },
};
</script>
<style lang='scss' scoped>
::v-deep .el-select-dropdown__item.selected {
  color: #685ef5;
}
</style>
